import { useEffect } from 'preact/hooks';
import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import CardService from '../../services/card.service';
import NavigationUtils from '../../utils/navigation.utils';
import { UrlEvent } from '../../sdk/url.event';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function SetPinPage({ organization, cardUid, cardNumber }) {
  useEffect(() => {
    CardService.setPin(organization, cardUid, {
      lastFourCardDigits: cardNumber,
    })
      .then(body => {
        TrackingEvent.trigger(
          TrackingEvent.Events.SET_PIN_SCREEN_SHOW,
          TrackingEvent.Sources.CAAS,
        );

        // ATTENTION: token query param will be remove later.
        UrlEvent.intercept(
          body.resetPinUrl,
          [
            {
              regex: '.*',
              url: `${window.location.origin}${NavigationUtils.Routes.SET_PIN_STATUS}?organization=${organization}&cardUid=${cardUid}&cardNumber=${cardNumber}`,
            },
          ],
          null,
          {
            headers: {
              token: body.token,
            },
          },
        );
      })
      .catch(() => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  return <LoadingScreen />;
}
